module.exports = __webpack_public_path__ + "static/media/floor_tom_5.81099b76.png";